import { useEffect, useState } from 'react';

/**
 * A value that settles.
 *
 * IT LIVED IN TWO COMPONENTS AND NOW THREE THINGS TYPE INTO A NETWORK: the room
 * search, the handle check on the card, and the GIF picker. Two copies of a hook
 * agree until the day one of them takes a second argument, so it is one copy —
 * the same reasoning `query-client.ts` gives about a query key.
 *
 * ONLY THE FETCH WAITS, NEVER THE FIELD. Every caller renders the raw value in
 * the input and debounces only what it sends: a character that appears a quarter
 * of a second after it was typed is a field that feels broken, whatever it saves.
 */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return settled;
}
